// services/StatelevelService.ts
import { appConfig } from "../config/appConfig";
import { decode } from "../utils/helper";
import { getStorageItemLocal } from "./storageServices";
import { fetchSasUrl } from "./IndiaService";
import { UPLOADTYPE } from "../models/enums/globalEnums";

export type AdminEntry = {
  id: number;
  category: string;

  subCategory: string;
  state: string;
  categoryName: string;
  stateName: string;
  description: string;
  description2: string;
  description3: string;
  imageUrls: string | string[];
  videoUrls: string | string[];
  thumbnail: string | string[];
  lastUpdated: string;
  pdfUrls: string | string[];
  pdfIsActive: boolean;
  pdfName: string;
  pdfUrls2: string | string[];
  pdfIsActive2: boolean;
  pdfName2: string;
  pdfUrls3: string | string[];
  pdfIsActive3: boolean;
  pdfName3: string;
  grid1: string | string[];
  gridThumbnail1: string | string[];
  gridType1: string;
  gridIconName1: string;
  grid2: string | string[];
  gridThumbnail2: string | string[];
  gridIconName2: string;
  gridType2: string;
  grid3: string | string[];
  gridThumbnail3: string | string[];
  gridType3: string;
  gridIconName3: string;
  grid4: string | string[];
  gridThumbnail4: string | string[];
  gridType4: string;
  gridIconName4: string;
  grid5: string | string[];
  gridThumbnail5: string | string[];
  gridType5: string;
  gridIconName5: string;
  grid6: string | string[];
  gridThumbnail6: string | string[];
  gridType6: string;
  gridIconName6: string;
  grid7: string | string[];
  gridThumbnail7: string | string[];
  gridType7: string;
  gridIconName7: string;
  grid8: string | string[];
  gridThumbnail8: string | string[];
  gridType8: string;
  gridIconName8: string;
  grid9: string | string[];
  gridThumbnail9: string | string[];
  gridType9: string;
  gridIconName9: string;
  isActive: boolean;
  uploadBy: string;
  approveBy: string;
  status: string;
  statusCode: string;
  publishBy: string;
};

export const defaultAdminEntry: AdminEntry = {
  id: 0,
  category: "",
  state: "",
  categoryName: "",
  stateName: "",
  subCategory: "",
  description: "",
  description2: "",
  description3: "",
  imageUrls: [],
  videoUrls: [],
  thumbnail: [],
  lastUpdated: new Date().toISOString(),
  pdfUrls: [],
  pdfIsActive: false,
  pdfName: "",
  pdfUrls2: [],
  pdfIsActive2: false,
  pdfName2: "",
  pdfUrls3: [],
  pdfIsActive3: false,
  pdfName3: "",
  grid1: [],
  gridThumbnail1: [],
  gridType1: "",
  gridIconName1: "",
  grid2: [],
  gridThumbnail2: [],
  gridType2: "",
  gridIconName2: "",
  grid3: [],
  gridThumbnail3: [],
  gridType3: "",
  gridIconName3: "",
  grid4: [],
  gridThumbnail4: [],
  gridType4: "",
  gridIconName4: "",
  grid5: [],
  gridThumbnail5: [],
  gridType5: "",
  gridIconName5: "",
  grid6: [],
  gridThumbnail6: [],
  gridType6: "",
  gridIconName6: "",
  grid7: [],
  gridThumbnail7: [],
  gridType7: "",
  gridIconName7: "",
  grid8: [],
  gridThumbnail8: [],
  gridType8: "",
  gridIconName8: "",
  grid9: [],
  gridThumbnail9: [],
  gridType9: "",
  gridIconName9: "",
  isActive: true,
  uploadBy: "",
  approveBy: "",
  status: "",
  statusCode: "",
  publishBy: "",
};

export const clearDefaultAdminEntry = (
  ID: number,
  category: string,
  state: string
): AdminEntry => ({
  id: ID,
  category: category,
  state: state,
  categoryName: "",
  stateName: "",
  subCategory: "",
  description: "",
  description2: "",
  description3: "",
  imageUrls: [],
  videoUrls: [],
  thumbnail: [],
  lastUpdated: new Date().toISOString(),
  pdfUrls: [],
  pdfIsActive: false,
  pdfName: "",
  pdfUrls2: [],
  pdfIsActive2: false,
  pdfName2: "",
  pdfUrls3: [],
  pdfIsActive3: false,
  pdfName3: "",
  grid1: [],
  gridThumbnail1: [],
  gridType1: "",
  gridIconName1: "",
  grid2: [],
  gridThumbnail2: [],
  gridType2: "",
  gridIconName2: "",
  grid3: [],
  gridThumbnail3: [],
  gridType3: "",
  gridIconName3: "",
  grid4: [],
  gridThumbnail4: [],
  gridType4: "",
  gridIconName4: "",
  grid5: [],
  gridThumbnail5: [],
  gridType5: "",
  gridIconName5: "",
  grid6: [],
  gridThumbnail6: [],
  gridType6: "",
  gridIconName6: "",
  grid7: [],
  gridThumbnail7: [],
  gridType7: "",
  gridIconName7: "",
  grid8: [],
  gridThumbnail8: [],
  gridType8: "",
  gridIconName8: "",
  grid9: [],
  gridThumbnail9: [],
  gridType9: "",
  gridIconName9: "",
  isActive: true,
  uploadBy: "",
  approveBy: "",
  status: "",
  statusCode: "",
  publishBy: "",
});

export const ensureArray = (value: any): string[] => {
  if (typeof value === "string") {
    return value
      .split(",")
      .map((v) => v.trim())
      .filter(Boolean);
  } else if (Array.isArray(value)) {
    return value;
  }
  return [];
};

export const prepareAdminEntryForEdit = (entry: any): AdminEntry => ({
  ...entry,
  imageUrls: ensureArray(entry.imageUrls),
  videoUrls: ensureArray(entry.videoUrls),
  thumbnail: ensureArray(entry.thumbnail),

  pdfUrls: ensureArray(entry.pdfUrls),
  pdfUrls2: ensureArray(entry.pdfUrls2),
  pdfUrls3: ensureArray(entry.pdfUrls3),

  grid1: ensureArray(entry.grid1),
  gridThumbnail1: ensureArray(entry.gridThumbnail1),
  grid2: ensureArray(entry.grid2),
  gridThumbnail2: ensureArray(entry.gridThumbnail2),
  grid3: ensureArray(entry.grid3),
  gridThumbnail3: ensureArray(entry.gridThumbnail3),
  grid4: ensureArray(entry.grid4),
  gridThumbnail4: ensureArray(entry.gridThumbnail4),
  grid5: ensureArray(entry.grid5),
  gridThumbnail5: ensureArray(entry.gridThumbnail5),
  grid6: ensureArray(entry.grid6),
  gridThumbnail6: ensureArray(entry.gridThumbnail6),
  grid7: ensureArray(entry.grid7),
  gridThumbnail7: ensureArray(entry.gridThumbnail7),
  grid8: ensureArray(entry.grid8),
  gridThumbnail8: ensureArray(entry.gridThumbnail8),
  grid9: ensureArray(entry.grid9),
  gridThumbnail9: ensureArray(entry.gridThumbnail9),
});

export const buildAdminEntryFormData = async (
  formData: AdminEntry,
  selectedImages: File[],
  selectedVideos: File[],
  selectedThumbnail: File[],
  editingIndex: number | null,
  selectedPdf: File[],
  selectedPdf2: File[],
  selectedPdf3: File[],
  ispdfChecked: boolean,
  ispdfChecked2: boolean,
  ispdfChecked3: boolean,
  isChecked: boolean,
  grid1: File[],
  grid2: File[],
  grid3: File[],
  grid4: File[],
  grid5: File[],
  grid6: File[],
  grid7: File[],
  grid8: File[],
  grid9: File[],

  gridThumbnail1: File[],
  gridThumbnail2: File[],
  gridThumbnail3: File[],
  gridThumbnail4: File[],
  gridThumbnail5: File[],
  gridThumbnail6: File[],
  gridThumbnail7: File[],
  gridThumbnail8: File[],
  gridThumbnail9: File[]
): Promise<FormData> => {
  const formDataToSend = new FormData();

  // For Existing files.
  const appendFiles = (files: File[], key: string) => {
    files.forEach((file) => formDataToSend.append(key, file));
  };
  const appendBlobFilesFromUrls = async (
    urls: string[] | string,
    key: string
  ) => {
    if (!urls) return;
    const list = Array.isArray(urls)
      ? urls.filter(Boolean)
      : urls
          .split(",")
          .map((v) => v.trim())
          .filter(Boolean);
    for (const url of list) {
      if (typeof url === 'string') {
        formDataToSend.append(key, url.split("?")[0]);
      }
    }
  };

  // Basic data
  formDataToSend.append("id", editingIndex?.toString() ?? "0");
  formDataToSend.append("category", formData.category);
  formDataToSend.append("state", formData.state.toString() ?? "0");
  formDataToSend.append("subcategory", formData.subCategory);
  formDataToSend.append("description", formData.description);
  formDataToSend.append("description2", formData.description2);
  formDataToSend.append("description3", formData.description3);
  formDataToSend.append("status", "Pending"); //Approved  Pending for Approval
  formDataToSend.append("pdfIsActive", ispdfChecked.toString());
  formDataToSend.append("pdfIsActive2", ispdfChecked2.toString());
  formDataToSend.append("pdfIsActive3", ispdfChecked3.toString());
  formDataToSend.append("isActive", formData.isActive.toString());
  formDataToSend.append("pdfName", formData.pdfName);
  formDataToSend.append("pdfName2", formData.pdfName2);
  formDataToSend.append("pdfName3", formData.pdfName3);

  formDataToSend.append("gridType1", formData.gridType1);
  formDataToSend.append("gridType2", formData.gridType2);
  formDataToSend.append("gridType3", formData.gridType3);
  formDataToSend.append("gridType4", formData.gridType4);
  formDataToSend.append("gridType5", formData.gridType5);
  formDataToSend.append("gridType6", formData.gridType6);
  formDataToSend.append("gridType7", formData.gridType7);
  formDataToSend.append("gridType8", formData.gridType8);
  formDataToSend.append("gridType9", formData.gridType9);
  formDataToSend.append("gridIconName1", formData.gridIconName1);
  formDataToSend.append("gridIconName2", formData.gridIconName2);
  formDataToSend.append("gridIconName3", formData.gridIconName3);
  formDataToSend.append("gridIconName4", formData.gridIconName4);
  formDataToSend.append("gridIconName5", formData.gridIconName5);
  formDataToSend.append("gridIconName6", formData.gridIconName6);
  formDataToSend.append("gridIconName7", formData.gridIconName7);
  formDataToSend.append("gridIconName8", formData.gridIconName8);
  formDataToSend.append("gridIconName9", formData.gridIconName9);

  const username = getStorageItemLocal("username") ?? "";
  formDataToSend.append("uploadBy", username);

  // Images: both selected and existing
  appendFiles(selectedImages, "imageUrls"); // prev image uploaded
  await appendBlobFilesFromUrls(formData.imageUrls, "imageUrls"); // new Image

  // Thumbnail: use new or existing one
  if (selectedThumbnail.length > 0) {
    appendFiles(selectedThumbnail, "thumbnail");
  } else if (formData.thumbnail) {
    await appendBlobFilesFromUrls(formData.thumbnail, "thumbnail");
  }

  // Videos: new or fallback to existing
  if (selectedVideos.length > 0) {
    appendFiles(selectedVideos, "videoUrls");
  } else {
    await appendBlobFilesFromUrls(formData.videoUrls, "videoUrls");
  }

  /// grid thumbnail
  if (gridThumbnail1.length > 0) {
    appendFiles(gridThumbnail1, "gridThumbnail1");
  } else {
    await appendBlobFilesFromUrls(formData.gridThumbnail1, "gridThumbnail1");
  }
  if (gridThumbnail2.length > 0) {
    appendFiles(gridThumbnail2, "gridThumbnail2");
  } else {
    await appendBlobFilesFromUrls(formData.gridThumbnail2, "gridThumbnail2");
  }

  if (gridThumbnail3.length > 0) {
    appendFiles(gridThumbnail3, "gridThumbnail3");
  } else {
    await appendBlobFilesFromUrls(formData.gridThumbnail3, "gridThumbnail3");
  }

  if (gridThumbnail4.length > 0) {
    appendFiles(gridThumbnail4, "gridThumbnail4");
  } else {
    await appendBlobFilesFromUrls(formData.gridThumbnail4, "gridThumbnail4");
  }

  if (gridThumbnail5.length > 0) {
    appendFiles(gridThumbnail5, "gridThumbnail5");
  } else {
    await appendBlobFilesFromUrls(formData.gridThumbnail5, "gridThumbnail5");
  }

  if (gridThumbnail6.length > 0) {
    appendFiles(gridThumbnail6, "gridThumbnail6");
  } else {
    await appendBlobFilesFromUrls(formData.gridThumbnail6, "gridThumbnail6");
  }

  if (gridThumbnail7.length > 0) {
    appendFiles(gridThumbnail7, "gridThumbnail7");
  } else {
    await appendBlobFilesFromUrls(formData.gridThumbnail7, "gridThumbnail7");
  }

  if (gridThumbnail8.length > 0) {
    appendFiles(gridThumbnail8, "gridThumbnail8");
  } else {
    await appendBlobFilesFromUrls(formData.gridThumbnail8, "gridThumbnail8");
  }

  if (gridThumbnail9.length > 0) {
    appendFiles(gridThumbnail9, "gridThumbnail9");
  } else {
    await appendBlobFilesFromUrls(formData.gridThumbnail9, "gridThumbnail9");
  }

  ///// grid media /////////////////////////////////

  // if (grid1.length > 0) {
  appendFiles(grid1, "grid1");
  // }
  if (formData.gridType1 === UPLOADTYPE.IMAGES || grid1.length === 0) {
    await appendBlobFilesFromUrls(formData.grid1, "grid1");
  }

  // if (grid2.length > 0) {
  appendFiles(grid2, "grid2");
  // }
  if (formData.gridType2 === UPLOADTYPE.IMAGES || grid2.length === 0) {
    await appendBlobFilesFromUrls(formData.grid2, "grid2");
  }

  // if (grid3.length > 0) {
  appendFiles(grid3, "grid3");
  // }
  if (formData.gridType3 === UPLOADTYPE.IMAGES || grid3.length === 0) {
    await appendBlobFilesFromUrls(formData.grid3, "grid3");
  }

  // if (grid4.length > 0) {
  appendFiles(grid4, "grid4");
  // }
  if (formData.gridType4 === UPLOADTYPE.IMAGES || grid4.length === 0) {
    await appendBlobFilesFromUrls(formData.grid4, "grid4");
  }

  // if (grid5.length > 0) {
  appendFiles(grid5, "grid5");
  // }
  if (formData.gridType5 === UPLOADTYPE.IMAGES || grid5.length === 0) {
    await appendBlobFilesFromUrls(formData.grid5, "grid5");
  }

  // if (grid6.length > 0) {
  appendFiles(grid6, "grid6");
  // }
  if (formData.gridType6 === UPLOADTYPE.IMAGES || grid6.length === 0) {
    await appendBlobFilesFromUrls(formData.grid6, "grid6");
  }

  // if (grid7.length > 0) {
  appendFiles(grid7, "grid7");
  // }
  if (formData.gridType7 === UPLOADTYPE.IMAGES || grid7.length === 0) {
    await appendBlobFilesFromUrls(formData.grid7, "grid7");
  }

  // if (grid8.length > 0) {
  appendFiles(grid8, "grid8");
  // }
  if (formData.gridType8 === UPLOADTYPE.IMAGES || grid8.length === 0) {
    await appendBlobFilesFromUrls(formData.grid8, "grid8");
  }

  // if (grid9.length > 0) {
  appendFiles(grid9, "grid9");
  // }
  if (formData.gridType9 === UPLOADTYPE.IMAGES || grid9.length === 0) {
    await appendBlobFilesFromUrls(formData.grid9, "grid9");
  }

  return formDataToSend;
};

async function withRetry<T>(operation: () => Promise<T>, maxRetries = 3): Promise<T> {
  let attempt = 0;
  while (attempt < maxRetries) {
    try {
      return await operation();
    } catch (error: any) {
      attempt++;
      if (attempt >= maxRetries) throw error;
      await new Promise(resolve => setTimeout(resolve, 1000 * attempt));
    }
  }
  throw new Error("Unreachable");
}


export const uploadToAzureBlob = async (
  file: File,
  containerName: string,
  sasUrl: string,
  pathPrefix: string,
  onProgress?: (loadedBytes: number) => void
): Promise<string> => {
  const urlParts = sasUrl.split("?");
  let baseUrl = urlParts[0];
  
  // Avoid double-appending the container name if the SAS URL already includes it
  if (!baseUrl.endsWith(`/${containerName}`) && !baseUrl.includes(`/${containerName}/`)) {
    baseUrl = baseUrl.endsWith("/") ? `${baseUrl}${containerName}` : `${baseUrl}/${containerName}`;
  }
  const query = urlParts[1] ? `?${urlParts[1]}` : "";

  const ticks = Date.now() * 10000 + 621355968000000000;
  const fileExtension = file.name.substring(file.name.lastIndexOf("."));
  const match = file.name.trim().match(/^\[\s*(\d+)\s*\]/);
  const prefix = match ? `[${match[1]}]_` : "";
  const blobName = `${pathPrefix}/${prefix}${ticks}${fileExtension}`;
  const uploadUrl = `${baseUrl}/${blobName}${query}`;

  console.log("[UPLOAD DEBUG] SAS URL received:", sasUrl.substring(0, 80) + "...");
  console.log("[UPLOAD DEBUG] Constructed upload URL:", uploadUrl.substring(0, 120) + "...");
  console.log("[UPLOAD DEBUG] File:", file.name, "Size:", file.size, "Type:", file.type);

  const performPut = (targetUrl: string, blobOriginHeader?: string) =>
    new Promise<string>((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("PUT", targetUrl, true);
      xhr.setRequestHeader("x-ms-blob-type", "BlockBlob");
      if (file.type) {
        xhr.setRequestHeader("Content-Type", file.type);
      }
      if (blobOriginHeader) {
        xhr.setRequestHeader("x-blob-target-origin", blobOriginHeader);
      }

      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable && onProgress) {
          onProgress(event.loaded);
        }
      };

      xhr.onload = () => {
        console.log("[UPLOAD DEBUG] onload status:", xhr.status, "response:", xhr.responseText?.substring(0, 200));
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve(`${baseUrl}/${blobName}`);
        } else {
          const err: any = new Error(`Upload failed with status ${xhr.status}: ${xhr.responseText?.substring(0, 100)}`);
          err.status = xhr.status;
          reject(err);
        }
      };

      xhr.onerror = () => {
        console.error("[UPLOAD DEBUG] XHR onerror fired. readyState:", xhr.readyState, "status:", xhr.status);
        console.error("[UPLOAD DEBUG] This usually means CORS blocked the request or network is down");
        console.error("[UPLOAD DEBUG] Upload URL was:", targetUrl.substring(0, 120));
        reject(new Error(`Network error during upload (readyState=${xhr.readyState}, status=${xhr.status})`));
      };

      xhr.ontimeout = () => {
        reject(new Error("Upload timed out"));
      };

      // Set a generous timeout (10 min) for large files
      xhr.timeout = 600000;

      xhr.send(file);
    });

  if (
    typeof window !== "undefined" &&
    (window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1")
  ) {
    try {
      const parsed = new URL(uploadUrl);
      const proxyPath = `/__blob_proxy${parsed.pathname}${parsed.search}`;
      try {
        return await performPut(proxyPath, parsed.origin);
      } catch (err: any) {
        if (err?.status === 404) {
          return await performPut(
            `http://localhost:3005${proxyPath}`,
            parsed.origin
          );
        }
        throw err;
      }
    } catch (err) {
      throw err;
    }
  }

  return performPut(uploadUrl);
};

export const saveAdminEntry = async (
  formData: AdminEntry,
  selectedImages: File[],
  selectedVideos: File[],
  selectedThumbnail: File[],
  editingIndex: number | null,
  apiBaseUrl: string,

  selectedPdf: File[],
  selectedPdf2: File[],
  selectedPdf3: File[],

  ispdfChecked: boolean,
  ispdfChecked2: boolean,
  ispdfChecked3: boolean,
  isChecked: boolean,
  grid1: File[],
  grid2: File[],
  grid3: File[],
  grid4: File[],
  grid5: File[],
  grid6: File[],
  grid7: File[],
  grid8: File[],
  grid9: File[],

  gridThumbnail1: File[],
  gridThumbnail2: File[],
  gridThumbnail3: File[],
  gridThumbnail4: File[],
  gridThumbnail5: File[],
  gridThumbnail6: File[],
  gridThumbnail7: File[],
  gridThumbnail8: File[],
  gridThumbnail9: File[],
  onProgress?: (fileName: string, loadedBytes: number, totalBytes: number) => void
): Promise<Response> => {
  const payload = new FormData();
  const formDataToSend = await buildAdminEntryFormData(
    formData,
    selectedImages,
    selectedVideos,
    selectedThumbnail,
    editingIndex,
    selectedPdf,
    selectedPdf2,
    selectedPdf3,
    ispdfChecked,
    ispdfChecked2,
    ispdfChecked3,
    isChecked,
    grid1,
    grid2,
    grid3,
    grid4,
    grid5,
    grid6,
    grid7,
    grid8,
    grid9,
    gridThumbnail1,
    gridThumbnail2,
    gridThumbnail3,
    gridThumbnail4,
    gridThumbnail5,
    gridThumbnail6,
    gridThumbnail7,
    gridThumbnail8,
    gridThumbnail9
  );

  let TokenUrl = await fetchSasUrl("file-uploads");

  const uploadTasks: (() => Promise<{ key: string; value: string }>)[] = [];

  const uniqueKeys = Array.from(new Set(formDataToSend.keys()));
  for (const key of uniqueKeys) {
    const values = formDataToSend.getAll(key);
    for (const value of values) {
      if (value instanceof File) {
        if (onProgress) onProgress(value.name, 0, value.size);
        uploadTasks.push(
          async () => {
            let pathPrefix = "State/others";
            if (value.type.startsWith("image/")) {
              pathPrefix = "State/images";
            } else if (value.type.startsWith("video/")) {
              pathPrefix = "State/videos";
            } else if (value.type === "application/pdf") {
              pathPrefix = "State/PDFs";
            }
            const uploadedUrl = await uploadToAzureBlob(
              value,
              "file-uploads",
              TokenUrl,
              pathPrefix,
              (loadedBytes) => {
                if (onProgress) onProgress(value.name, loadedBytes, value.size);
              }
            );
            let cleanUrl = uploadedUrl.split("?")[0];
            const match = key.match(/^grid(\d)$/);
            if (match) {
              cleanUrl = `${cleanUrl}?grid=${match[1]}`;
            }
            return { key, value: cleanUrl };
          }
        );
      } else {
        uploadTasks.push(async () => {
          let valStr = value.toString();
          const match = key.match(/^grid(\d)$/);
          if (match && valStr && valStr.startsWith("http")) {
            const cleanUrl = valStr.split("?")[0];
            valStr = `${cleanUrl}?grid=${match[1]}`;
          }
          return { key, value: valStr };
        });
      }
    }
  }

  const results: { key: string; value: string }[] = [];
  const CONCURRENCY_LIMIT = 1;
  for (let i = 0; i < uploadTasks.length; i += CONCURRENCY_LIMIT) {
    const chunk = uploadTasks.slice(i, i + CONCURRENCY_LIMIT).map(task => task());
    const chunkResults = await Promise.all(chunk);
    results.push(...chunkResults);
  }

  const groupedResults = results.reduce((acc, curr) => {
    if (!acc[curr.key]) acc[curr.key] = [];
    acc[curr.key].push(curr.value);
    return acc;
  }, {} as Record<string, string[]>);

  for (const key in groupedResults) {
    payload.set(key, groupedResults[key].join(","));
  }

  const tokenString = getStorageItemLocal("token");
  const token = tokenString ? JSON.parse(tokenString) : null;

  const url =
    editingIndex !== null && editingIndex < 900
      ? `${apiBaseUrl}/${formData.id}`
      : `${apiBaseUrl}/upload`;

  const res = await fetch(url, {
    method: editingIndex !== null && editingIndex < 900 ? "PUT" : "POST",
    body: payload,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (Number(formData.category) > 10) {
    try {
      const { saveExtraStateEntryLocal, syncExtraCategoriesToBlob } = await import(
        "./ExtraCategoriesSyncService"
      );
      const savedObj: Record<string, any> = {
        ...formData,
        id: editingIndex ?? Number(formData.category) + 900,
        category: Number(formData.category),
        isActive: isChecked,
        status: "Published",
        statusCode: "3",
        lastUpdated: new Date().toISOString(),
      };
      for (const key in groupedResults) {
        savedObj[key] = groupedResults[key].join(",");
      }
      await saveExtraStateEntryLocal(savedObj);
      await syncExtraCategoriesToBlob();
    } catch (e) {
      console.warn("Extra category State sync warning:", e);
    }
  }

  if (Number(formData.category) > 10 && !res.ok) {
    return new Response(JSON.stringify({ ok: true }), { status: 200 });
  }
  return res;
};

export const removeImageByIndex = (
  imageArray: string[] | string,
  indexToRemove: number
): string[] => {
  // Handle case where imageArray is a single string without commas
  if (typeof imageArray === "string") {
    if (!imageArray.includes(",")) {
      return indexToRemove === 0 ? [] : [imageArray];
    }

    const images = imageArray
      .split(",")
      .map((img) => img.trim())
      .filter(Boolean);

    return images.filter((_, index) => index !== indexToRemove);
  }

  const temp = imageArray.filter((_, index) => index !== indexToRemove);

  // Handle case where imageArray is already an array
  return imageArray.filter((_, index) => index !== indexToRemove);
};

export const removeVideoByIndex = (
  videoArray: string[] | string,
  indexToRemove: number
): string[] => {
  if (typeof videoArray === "string") {
    if (!videoArray.includes(",")) {
      return indexToRemove === 0 ? [] : [videoArray];
    }

    const videos = videoArray
      .split(",")
      .map((v) => v.trim())
      .filter(Boolean);

    return videos.filter((_, index) => index !== indexToRemove);
  }

  // videoArray is already an array
  return videoArray.filter((_, index) => index !== indexToRemove);
};
